import React from 'react';
import { ResetPassword } from './container';

export const ResetPasswordScreen = () => {
    return <ResetPassword />;
};
